import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CcExpiryValidatorDirective } from './cc-expiry-validator.directive';
import { DecimalValidatorDirective } from './decimal-validator.directive';
import { EmailValidatorDirective } from './email-validator.directive';
import { IntValidatorDirective } from './int-validator.directive';
import { PasswordValidatorDirective } from './password-validator.directive';
import { PhoneValidatorDirective } from './phone-validator.directive';

@NgModule({
    imports: [CommonModule],
    declarations: [
        CcExpiryValidatorDirective,
        DecimalValidatorDirective,
        EmailValidatorDirective,
        IntValidatorDirective,
        PasswordValidatorDirective,
        PhoneValidatorDirective,
    ],
    exports: [
        CcExpiryValidatorDirective,
        DecimalValidatorDirective,
        EmailValidatorDirective,
        IntValidatorDirective,
        PasswordValidatorDirective,
        PhoneValidatorDirective,
    ],
})
export class StringValidatorsModule
{
}
